require('./script-validate');
require('./script-add-mask');
require('./script-message');
require('./script-get-address');
require('./script-person-type');


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/common.js